/** Shared bounds for reviewed opening balances, never for existing stock updates. */
export const MAX_IMPORT_OPENING_QUANTITY = 1_000_000;

export function validImportOpeningQuantity(value: unknown): value is number {
  return typeof value === "number" && Number.isSafeInteger(value) && value >= 0 && value <= MAX_IMPORT_OPENING_QUANTITY;
}

export function parseImportOpeningQuantity(value: string): number | undefined {
  const trimmed = value.trim();
  if (!/^\d+$/.test(trimmed)) return undefined;
  const quantity = Number(trimmed);
  return validImportOpeningQuantity(quantity) ? quantity : undefined;
}
